<template>
    <div class="mwl-auto-complete" :class="{ open: dropdown.open }" @click.stop="">
        <input type="text"
            :class="input_class"
            :placeholder="placeholder"
            :value="value"
            @input="updateValue($event.target.value)"
            @blur="inputBlur"
            @keyup="inputKeyup"
            @keyup.enter="selectActiveSuggestion"
            @keyup.down="inputDownArrow"
            @keyup.up="inputUpArrow"
            @keydown.tab="closeSuggestions"
        />
        <ul class="dropdown-menu">
            <li v-for="(suggestion, index) in matches"
                ref="suggestions"
                class="dropdown-item"
                :class="{ active: index == dropdown.active_item }"
                @click.stop="selectSuggestion(index)"
            >
                <a href="#" tabindex="-1" v-html="suggestion.display_text"></a>
            </li>
        </ul>
    </div>
</template>
<style lang="scss">
    @import '../../sass/_global_variables.scss';

    .mwl-auto-complete {
        position: relative;

        .dropdown-menu {
            width: 100%;
            padding: 0;
            max-height: 200px;
            overflow-y: auto;

            .dropdown-item {
                padding: 0;

                &:hover, &:focus, &.active {
                    background-color: $background-gray;

                    a {
                        color: #000000;
                    }
                }
            }
        }
    }
</style>
<script type="text/ecmascript-6">
    export default {
        props: {
            value: { type: String, default: '' },
            suggestions: { type: Array, default() { return [] } },
            input_class: { type: String, default: 'form-control focus-border' },
            placeholder: { type: String, default: '' },
            search_field: { default: 'value' },
            format_suggestion: { type: Function, default: null },
            case_sensitive: { type: Boolean, default: false }
        },
        computed: {
            matches () {
                let suggestions = this.suggestions.filter(suggestion => {
                    if ((typeof suggestion != 'string' && !_.has(suggestion, this.search_field)) || !this.value) return false;

                    let text = typeof suggestion == 'string' ? suggestion : suggestion[this.search_field];

                    if (this.case_sensitive) {
                        return text.indexOf(this.value) >= 0;
                    }
                    else {
                        return text.toLowerCase().indexOf(this.value.toLowerCase()) >= 0;
                    }
                })
                .map(suggestion => {
                    suggestion.display_text = this.formatSuggestion(suggestion);
                    suggestion.uniqBy = this.case_sensitive ? suggestion.display_text : suggestion.display_text.toLowerCase();
                    return suggestion;
                });

                return _.uniqBy(suggestions, 'uniqBy');
            }
        },
        data () {
            return {
                dropdown: {
                    open: false,
                    active_item: 0
                }
            }
        },
        methods: {
            inputDownArrow () {
                if (!this.dropdown.open) return;

                if (this.dropdown.active_item < this.matches.length - 1) {
                    ++this.dropdown.active_item;
                }
                this.$refs.suggestions[this.dropdown.active_item].scrollIntoView(false, { behavior: 'smooth' });
            },
            inputUpArrow () {
                if (!this.dropdown.open) return;

                if (this.dropdown.active_item > 0) {
                    --this.dropdown.active_item;
                }
                this.$refs.suggestions[this.dropdown.active_item].scrollIntoView(false, { behavior: 'smooth' });
            },
            inputBlur () {
                if (!this.dropdown.open) {
                    this.$emit('blur');
                }
            },
            inputKeyup () {
                if (this.value.length > 2 && this.matches.length > 0) {
                    Vue.set(this.dropdown, 'open', true);
                }
                else if (this.dropdown.open) {
                    Vue.set(this.dropdown, 'open', false);
                }

                this.$emit('keyup');
            },
            closeSuggestions (emit_blur=true) {
                if (this.dropdown.open) {
                    emit_blur = true;
                }

                Vue.set(this.dropdown, 'open', false);
                Vue.set(this.dropdown, 'active_item', 0);

                if (emit_blur) {
                  this.$emit('blur');
                }
            },
            formatSuggestion (suggestion) {
                if (typeof this.format_suggestion === 'function') {
                    return this.format_suggestion(suggestion);
                }

                if (typeof suggestion == 'string') {
                    return suggestion;
                }
                else {
                    return suggestion[this.search_field];
                }
            },
            selectActiveSuggestion () {
                if (!this.dropdown.open) return;

                this.selectSuggestion(this.dropdown.active_item);
            },
            selectSuggestion (index) {
                if (!this.dropdown.open) return;

                if (index >= 0 && _.has(this.matches, index)) {
                    const suggestion = this.matches[index];
                    const text = typeof suggestion == 'string' ? suggestion : suggestion[this.search_field];
                    this.$emit('selected', suggestion);
                    this.$emit('input', text);
                    this.closeSuggestions();
                }
            },
            updateValue (value) {
                this.$emit('input', value);
            }
        },
        mounted () {
            document.addEventListener('click', () => {
              this.closeSuggestions(false);
            });
        }
    }
</script>



// WEBPACK FOOTER //
// auto-complete.vue?7626a6f8